export default __webpack_public_path__ + "static/media/Ring.696d6996.png";